export default __webpack_public_path__ + "static/media/insightsIcon.dee19938.svg";